var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "summary-details" }, [
    _c("div", { staticClass: "filter-container" }, [
      _vm.$store.getters.isPii
        ? _c("div", { staticClass: "tips" }, [
            _c(
              "span",
              [
                _c("svg-icon", {
                  staticStyle: { color: "#3855F1" },
                  attrs: { "icon-class": "icon-font-warning" },
                }),
              ],
              1
            ),
            _vm._v(_vm._s(_vm.$t("tips.current_time_zone"))),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "right" },
        [
          _c("span", { staticClass: "transTime" }, [
            _vm._v(_vm._s(_vm.$t("components.date")) + ":"),
          ]),
          _c("el-date-picker", {
            staticClass: "picker",
            attrs: {
              size: "small",
              format: "yyyy-MM-dd",
              "value-format": "yyyy-MM-dd",
              type: "daterange",
              "range-separator": "~",
              "start-placeholder": _vm.$t("components.start_date"),
              "end-placeholder": _vm.$t("components.end_date"),
            },
            model: {
              value: _vm.search.times,
              callback: function ($$v) {
                _vm.$set(_vm.search, "times", $$v)
              },
              expression: "search.times",
            },
          }),
          _c(
            "el-button",
            {
              staticClass: "search-btn",
              attrs: { size: "small", type: "primary", icon: "el-icon-search" },
              on: { click: _vm.balanceSummary },
            },
            [_vm._v(_vm._s(_vm.$t("components.search")))]
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "tableContainer" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            staticClass: "tableContainer",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              stripe: "",
              fit: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("components.date"),
                align: "center",
                "min-width": "105",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [_vm._v(_vm._s(scope.row.statistics_date))]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.loan_amount"),
                prop: "payout_amount",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(scope.row.payout_amount)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.loan_fee"),
                prop: "payout_fee",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(scope.row.payout_fee)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.postpone_amount"),
                align: "center",
                "min-width": "90",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(scope.row.postpone_amount)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.real_time_settlement_amount"),
                align: "center",
                "min-width": "90",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              scope.row.real_settlement_amount
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c(
              "el-table-column",
              {
                attrs: { align: "center", "min-width": "95" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                scope.row.payment_refund_amount
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              },
              [
                _c(
                  "template",
                  { slot: "header" },
                  [
                    _vm._v(" " + _vm._s(_vm.$t("data.refund_amount")) + " "),
                    _c("el-tooltip", { attrs: { placement: "top" } }, [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("span", [
                            _vm._v(
                              " " + _vm._s(_vm.$t("tips.refund_amount_tip"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("br"),
                        ]
                      ),
                      _c(
                        "span",
                        [
                          _c("svg-icon", {
                            staticClass: "icon-question",
                            attrs: { "icon-class": "icon-font-question" },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              2
            ),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("customerService.refund_fee"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(scope.row.refund_fee)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.refund_amount_fail"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              scope.row.payment_refund_fail_amount
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("customerService.refund_failed_fee"),
                align: "center",
                "min-width": "90",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              scope.row.refund_failed_fee
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.card_verification_fee"),
                align: "center",
                "min-width": "90",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              scope.row.card_validation_fee
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.card_verification_failed_fee_refund"),
                align: "center",
                "min-width": "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              scope.row.card_validation_refund_fee
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: _vm.$t("data.frozen_amount"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(scope.row.frozen_amount)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: _vm.$t("data.unfrozen_amount"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(scope.row.unfrozen_amount)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: _vm.$t("data.top_up"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("toDivideWithDot")(scope.row.deposit))
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: _vm.$t("data.cash_out"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("toDivideWithDot")(scope.row.cash_out))
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: _vm.$t("data.cashout_fail"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              scope.row.fail_withdraw_refund_amount
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm.$store.getters.isID || _vm.$store.getters.isPii
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("map.balance_type_31"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("toDivideWithDot")(
                                    scope.row.split_payment_out
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    857753804
                  ),
                })
              : _vm._e(),
            _vm.$store.getters.isID || _vm.$store.getters.isPii
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("map.balance_type_34"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("toDivideWithDot")(
                                    scope.row.split_payment_return_in
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    589345264
                  ),
                })
              : _vm._e(),
            _vm.$store.getters.isID || _vm.$store.getters.isPii
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("map.balance_type_32"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("toDivideWithDot")(
                                    scope.row.split_payment_in
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3115336453
                  ),
                })
              : _vm._e(),
            _vm.$store.getters.isID || _vm.$store.getters.isPii
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("map.balance_type_33"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("toDivideWithDot")(
                                    scope.row.split_payment_return_out
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    182592281
                  ),
                })
              : _vm._e(),
            _vm.$store.getters.isID
              ? _c("el-table-column", {
                  attrs: { label: _vm.$t("data.transfer"), align: "center" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("toDivideWithDot")(scope.row.transfer)
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2768138081
                  ),
                })
              : _vm._e(),
            _vm.hasReverse
              ? _c("el-table-column", {
                  attrs: { label: _vm.$t("data.reverse"), align: "center" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("toDivideWithDot")(
                                    scope.row.reverse_amount
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    358162393
                  ),
                })
              : _vm._e(),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.abnormal_adjustment_credit_balance"),
                align: "center",
                "min-width": "130",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              scope.row.abnormal_adjustment_credit
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.abnormal_adjustment_credit_frozen"),
                align: "center",
                "min-width": "130",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              scope.row.frozen_abnormal_adjustment_credit
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.abnormal_adjustment_debit_balance"),
                align: "center",
                "min-width": "130",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              scope.row.abnormal_adjustment_debit
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.abnormal_adjustment_debit_frozen"),
                align: "center",
                "min-width": "130",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              scope.row.frozen_abnormal_adjustment_debit
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.frozen_amount_balance"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("toDivideWithDot")(scope.row.frozen_balance)
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm.$store.getters.isOpenFXFunction
              ? [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("map.balance_type_23"),
                      prop: "fx_transfer_out_amount",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("toDivideWithDot")(
                                      scope.row.fx_transfer_out_amount
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3801739106
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("map.balance_type_24"),
                      prop: "fx_transfer_in_amount",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("toDivideWithDot")(
                                      scope.row.fx_transfer_in_amount
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4272669643
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("map.balance_type_25"),
                      prop: "fx_reversal_transfer_out_amount",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("toDivideWithDot")(
                                      scope.row.fx_reversal_transfer_out_amount
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1570175253
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("map.balance_type_26"),
                      prop: "fx_reversal_transfer_in_amount",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("toDivideWithDot")(
                                      scope.row.fx_reversal_transfer_in_amount
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      343131996
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("data.fx_transfer_out_fee"),
                      prop: "fx_transfer_out_fee",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("toDivideWithDot")(
                                      scope.row.fx_transfer_out_fee
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4125283656
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("data.fx_reversal_transfer_in_fee"),
                      prop: "fx_reversal_transfer_in_fee",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("toDivideWithDot")(
                                      scope.row.fx_reversal_transfer_in_fee
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2794889334
                    ),
                  }),
                ]
              : _vm._e(),
            _c("el-table-column", {
              attrs: { label: _vm.$t("map.balance_type_35"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              scope.row.settlement_advance_fee
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm.$store.getters.nsdsStatus && _vm.isHkCountry
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("map.balance_type_28"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("toDivideWithDot")(
                                    scope.row.nsds_charge_amount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2338054157
                  ),
                })
              : _vm._e(),
            _vm.$store.getters.nsdsStatus
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("map.balance_type_38"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("toDivideWithDot")(
                                    scope.row.nsds_deduction_amount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    709053752
                  ),
                })
              : _vm._e(),
            _c("el-table-column", {
              attrs: { label: _vm.$t("data.balance"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("toDivideWithDot")(scope.row.balance))
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            !_vm.listLoading
              ? _c("paginator", {
                  attrs: { "list-query": _vm.listQuery },
                  on: { "paginator-change": _vm.onClickPaginator },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }